import React from 'react';
import { SlControlPlay } from "react-icons/sl";

export const PlayerControls = ({ 
  state, 
  segment, 
  rate, 
  setRate, 
  onPlaySentence,
  audioref 
}) => {
  if (!state.hasOwnProperty("canplay")) return null;

  return (
    <div className="flex flex-col lg:flex-row items-center gap-4 w-full">
      {/* Play Button - Mobile Optimized */}
      <button
        className="flex items-center justify-center gap-2 px-4 py-3 lg:px-6 lg:py-4 bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 border border-blue-400/30 rounded-xl lg:rounded-2xl transition-all duration-300 shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40 group w-full lg:w-auto"
        onClick={onPlaySentence}
      >
        <div className="w-6 h-6 lg:w-8 lg:h-8 bg-white/20 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
          <SlControlPlay className="text-white text-sm lg:text-lg" />
        </div>
        <span className="text-white font-medium text-sm lg:text-base">Play Sentence</span>
        <span className="text-white/70 text-xs ml-1 lg:ml-2">(Space)</span>
      </button>

      {/* Speed Controls - Mobile Stacked */}
      <div className="flex flex-col lg:flex-row items-center gap-2 w-full lg:w-auto">
        <span className="text-sm font-medium text-gray-700 whitespace-nowrap text-center lg:text-left w-full lg:w-auto">Speed:</span>
        <div className="flex gap-1 w-full justify-center lg:justify-start">
          {[1, 0.5, 0.25].map((r) => (
            <button
              key={r}
              onClick={() => {
                setRate(r);
                if (audioref.current) audioref.current.playbackRate = r;
              }}
              className={`px-2 py-1 lg:px-3 lg:py-1 text-xs lg:text-sm font-medium rounded-lg border transition-all duration-300 flex-1 max-w-24 ${
                rate === r
                  ? "bg-gradient-to-r from-blue-500 to-indigo-500 text-white shadow-lg shadow-blue-500/25 border-blue-400/30"
                  : "bg-white/60 text-gray-700 border-white/40 hover:bg-white hover:shadow-md"
              }`}
            >
              <span className="hidden xs:inline">
                {r === 1 ? "Normal" : r === 0.5 ? "Slow" : "Slowest"}
              </span>
              <span className="xs:hidden">
                {r === 1 ? "1x" : r === 0.5 ? "0.5x" : "0.25x"}
              </span>
              <span className="text-xs ml-1 opacity-70 hidden sm:inline">
                ({r === 1 ? '1' : r === 0.5 ? '2' : '3'})
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};